export default __webpack_public_path__ + "static/media/miguel.83b71a27.png";